import { render, staticRenderFns } from "./ModalCdn.vue?vue&type=template&id=70c0b643&"
import script from "./ModalCdn.vue?vue&type=script&lang=js&"
export * from "./ModalCdn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports